module.exports = __webpack_public_path__ + "media/images/twitter-rounded-square-bd5ab472b19bf88c747598badb052457.svg";